var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGband(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.75 6.2041H5.25C3.59315 6.2041 2.25 7.54725 2.25 9.2041V15.2041C2.25 16.861 3.59315 18.2041 5.25 18.2041H18.75C20.4069 18.2041 21.75 16.861 21.75 15.2041V9.2041C21.75 7.54725 20.4069 6.2041 18.75 6.2041Z",
    stroke: "#636980",
    strokeWidth: 1.14286,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12 14.4541C13.2426 14.4541 14.25 13.4467 14.25 12.2041C14.25 10.9615 13.2426 9.9541 12 9.9541C10.7574 9.9541 9.75 10.9615 9.75 12.2041C9.75 13.4467 10.7574 14.4541 12 14.4541Z",
    stroke: "#636980",
    strokeWidth: 1.14286,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGband);
export default __webpack_public_path__ + "static/media/gband.deba40e9b3832bba3bbb06e55d863747.svg";
export { ForwardRef as ReactComponent };